// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import { MediaQueryInit } from '@brr-dev/react-media-queries';

export const MediaQueries = MediaQueryInit({
    small: 400,
    medium: 525,
    large: 675,
    xLarge: 850,
    xxLarge: 1000,
});
